import type { WebinarPartecipante } from '@aulaviva/shared';
import { Badge } from '@aulaviva/ui';
import { Building2, CircleCheck, CircleHelp, CircleX, Flag, Wifi } from 'lucide-react';
import { percorsi } from '@/testi';

/** Etichetta dello stato della conferma del partecipante: icona e parola, mai solo colore. */
export function StatoConferma({ webinar }: { webinar: WebinarPartecipante }) {
  const c = webinar.conferma;
  if (webinar.stato === 'chiuso')
    return (
      <Badge icon={Flag} variant="neutral">
        {percorsi.stati.chiuso}
      </Badge>
    );
  if (!c)
    return (
      <Badge icon={CircleHelp} variant="neutral">
        {percorsi.stati.nonInvitato}
      </Badge>
    );
  if (c.stato === 'rinunciato')
    return (
      <Badge icon={CircleX} variant="error">
        {percorsi.stati.rinunciato}
      </Badge>
    );
  if (c.stato === 'confermato')
    return (
      <Badge icon={c.modalita === 'sala' ? Building2 : Wifi} variant="success">
        {c.modalita === 'sala' ? percorsi.stati.confermatoSala : percorsi.stati.confermatoOnline}
      </Badge>
    );
  return (
    <Badge icon={CircleCheck} variant="warning">
      {percorsi.stati.invitato}
    </Badge>
  );
}
